module.exports = __webpack_public_path__ + "static/img/triangle.8ee6b81a.svg";